/**
 * Created by b032151 on 6/22/2017.
 */

import { ServerAPI } from '../actions/serverAPI';
import Constants from '../constants/constants';
import { dispatcher } from '../dispatcher/dispatcher';

const { ActionTypes } = Constants;

export const SlsActions = {
    loadSlsItems() {
        dispatcher.dispatch({
            type: ActionTypes.LOAD_SLS_ITEMS_STARTED
        });

        var serverCall = ServerAPI.getItemList();

        serverCall.done(function (data) {
            console.log("Success retrieving sls list:", data);
            dispatcher.dispatch({
                type: ActionTypes.LOAD_SLS_ITEMS_DONE,
                data: data.data
            });
        });

        serverCall.fail(function (data) {
            console.log('Failed retrieving sls list', data);
        });
    },

    loadResendItem() {
        dispatcher.dispatch({
            type: ActionTypes.LOAD_RESEND_ITEM
        });
    },

    loadSlsItem(params) {
        dispatcher.dispatch({
            type: ActionTypes.LOAD_SLS_ITEM_STARTED
        });

        var serverCall = ServerAPI.getItem(params);

        serverCall.done(function (data) {
            console.log("Success retrieving item:", data);
            dispatcher.dispatch({
                type: ActionTypes.LOAD_SLS_ITEM_DONE,
                data: data.data
            });
        });

        serverCall.fail(function (data) {
            console.log('Failed retrieving item', data);
        });
    },

    updateItem(item) {
        dispatcher.dispatch({
            type: ActionTypes.SLS_ITEM_UPDATING
        });

        var serverCall = ServerAPI.updateItem(item);

        serverCall.done(function (data) {
            console.log("Item updated successfully");

            if(data.success === true) {
                dispatcher.dispatch({
                    type: ActionTypes.SLS_ITEM_UPDATE_SUCCESS,
                    data: data.data
                });
            } else {
                dispatcher.dispatch({
                    type: ActionTypes.SLS_ITEM_UPDATE_FAIL,
                    data: data.data
                });
            }
        });

        serverCall.fail(function (data) {
            console.log('Failed retrieving item', data);
            dispatcher.dispatch({
                type: ActionTypes.SLS_ITEM_UPDATE_FAIL
            });
        });
    },

    resendItem(item, printLata) {
        let serverCall = ServerAPI.resendItem(item, printLata);

        serverCall.done(function (data) {
            if (data.success) {
                dispatcher.dispatch({
                    type: ActionTypes.SLS_RESEND_SUCCESS,
                    data: data.data
                });
            }
            else if (data.errors && data.errors.length > 0) {
                console.error(data.errors[0].field, data.errors[0].message);
                dispatcher.dispatch({
                    type: ActionTypes.SLS_RESEND_FAIL
                });
            }
            else {
                console.error("Item save failed");
                dispatcher.dispatch({
                    type: ActionTypes.SLS_RESEND_FAIL
                });
            }

        });

        serverCall.fail(function (data) {
            console.error('Failed resend item', data);
            dispatcher.dispatch({
                type: ActionTypes.SLS_RESEND_FAIL
            });
        });
    },

    clearSlsItem() {
        dispatcher.dispatch({
            type: ActionTypes.SLS_ITEM_CLEAR
        });
    },

    clearResendItem() {
        dispatcher.dispatch({
            type: ActionTypes.RESEND_ITEM_CLEAR
        });
    },

    changeSearchBy(value) {
        dispatcher.dispatch({
            type: ActionTypes.CHANGE_SLS_SEARCH_BY,
            value: value
        });
    },

    filterSlsItems(value) {
        dispatcher.dispatch({
            type: ActionTypes.FILTER_SLS_ITEMS,
            value: value
        });
    },
};
